<div class="card-view">
  <div *ngFor="let template of templates">
    <email-card
      [email]="template"
      [defaultAction]="defaultAction"
      [readOnly]="openAsReadOnly"
      [userId]="userId"
      [ownerType]="ownerType"
      (deleteRequested)="handleDeleteClicked($event)"
      (duplicateRequested)="handleDuplicateClicked($event)"
      (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
    ></email-card>
  </div>
</div>
